export const useHasAIAccess = () => {
  return process.env.REACT_APP_AI_ENABLED === "1";
};
